export default __webpack_public_path__ + "42e6fce6613b6aa059f2de05857ad567.png";